import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {Trans} from 'react-i18next';

export default function ProcessingInProgressModal({show, onHide}) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <Trans i18nKey="p.s.uiconfiguration.processing.in.progress.title">
            Processing in Progress
          </Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <Trans i18nKey="p.s.uiconfiguration.processing.in.progress.desc">
            The system is currently processing. Please wait until the process is
            complete before saving changes.
          </Trans>
        </p>
      </Modal.Body>
    </Modal>
  );
}
